import { afterNextRender, Component, ElementRef } from '@angular/core';
import { IChangePasswordLabelModel } from 'src/app/shared/types/shared-state';

@Component({
    selector: 'bmt-update-password',
    templateUrl: './update-password.component.html',
    styleUrls: ['./update-password.component.scss'],
    standalone: false
})
export class UpdatePasswordComponent {
  maxLength = 25;
  validationParts = {
    lowercase: /[a-z]/,
    uppercase: /[A-Z]/,
    number: /\d/,
    special: /[$@!%?&^#*,]/
  };
  labels: IChangePasswordLabelModel = {
    title: '',
    description: '',
    changePasswordBtn: 'Change Password',
    changePasswordFailed: 'Failed to change password, please check requirements and try again.',
    changePasswordSuccess: 'Successfully updated password.',
    changePasswordFailed400: 'Failed to change password, please check requirements and try again.',
    changePasswordFailed500: 'Failed to change password, please check requirements and try again.',
    changePasswordFailed400Default: 'Failed to change password, please check requirements and try again.'
  };

  constructor(private readonly elRef: ElementRef) {
    afterNextRender(() => {
      const changePasswordButton = this.elRef.nativeElement.querySelector('button');
      if (changePasswordButton) {
        changePasswordButton.click();
      }
    });
  }
}
